export const GET_WEATHER = 'GET_WEATHER';
export const GET_ECOCONSEILS = 'GET_ECOCONSEILS'
export const SET_WEATHER = 'SET_WEATHER';
export const SET_ECOCONSEILS = 'SET_ECOCONSEILS';
export const SET_PRODUCTION_TYPES = 'SET_PRODUCTION_TYPES';
export const GET_PRODUCTION_TYPES = 'GET_PRODUCTION_TYPES';
export const GET_COORDINATES = 'GET_COORDINATES';
export const SET_COORDINATES = 'SET_COORDINATES';